module.exports = __webpack_public_path__ + "static/img/direction.96fe9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/SubSection/direction.png
// module id = i3vO
// module chunks = 1